export default "__VITE_ASSET__DEoRlsLl__"